import React from 'react';
import { CompetitionDetails } from '../../CompetitionDetails';

export const ResultDetails: React.FC = (): JSX.Element => {
  return <CompetitionDetails variant="results" />;
};
